"use client";

import { ErrorBoundary } from "@offstreetparking/instrumentation/client";
import type { ReactNode } from "react";
import { UnhandledRunTimeError } from "~/components/feedback/UnhandledRunTimeError";
import { useParker } from "~/components/providers/AuthProvider";

export function ErrorBoundaryProvider({ children }: { children: ReactNode }) {
	const { parker } = useParker();
	const parkerId = parker && "id" in parker ? parker.id : undefined;
	return (
		<ErrorBoundary
			fallback={({ eventId, error }: { eventId: string | null; error: unknown }) => (
				<UnhandledRunTimeError
					eventId={eventId}
					error={error}
					parkerId={parkerId}
					onReload={() => window.location.reload()}
				/>
			)}
		>
			{children}
		</ErrorBoundary>
	);
}
